<template>
  <q-layout view="hHh LpR fFf">
    <q-header class="bg-white text-dark" bordered>
      <q-toolbar class="q-mx-auto" style="max-width: 1200px">
        <img
          src="@/assets/logo.png"
          class="q-my-sm"
          style="width: 48px; height: 40px"
          alt=""
        />

        <div class="row q-ml-xl self-stretch gt-sm" style="width: 100%">
          <q-tabs indicator-color="transparent" stretch>
            <q-route-tab
              v-for="(menuItem, index) of allowedMenuItems"
              :key="index"
              :to="menuItem.path"
              :label="menuItem.label"
              no-caps
              active-class="text-primary bg-blue-1"
            >
            </q-route-tab>
          </q-tabs>

          <q-space />

          <q-btn flat stretch>
            <q-avatar
              text-color="white"
              :style="{ backgroundColor: accountInfo.user.avatar.color }"
            >
              {{ accountInfo.user.avatar.abbr }}
            </q-avatar>

            <q-menu anchor="bottom right" self="top right">
              <q-list style="min-width: 100px">
                <q-item
                  v-if="$isAllowed('dealer/account/get')"
                  :to="{ name: 'Account' }"
                  clickable
                  v-close-popup
                >
                  <q-item-section>
                    {{ accountInfo.user.fullName }}
                  </q-item-section>
                </q-item>

                <q-item clickable v-close-popup @click="confirmSignOut">
                  <q-item-section>
                    {{ $t('layouts.default.drawer.menu.signOut') }}
                  </q-item-section>
                </q-item>
              </q-list>
            </q-menu>
          </q-btn>
        </div>

        <q-space />

        <q-btn
          aria-label="Menu"
          icon="menu"
          class="lt-md"
          flat
          stretch
          @click="leftDrawerOpen = !leftDrawerOpen"
        />
      </q-toolbar>
    </q-header>

    <q-drawer
      v-model="leftDrawerOpen"
      behavior="mobile"
      show-if-above
      bordered
      class="bg-grey-2"
    >
      <q-list class="full-height column">
        <q-item
          v-for="(menuItem, index) of allowedMenuItems"
          :key="index"
          :to="menuItem.path"
          tag="a"
          clickable
          exact
        >
          <q-item-section avatar>
            <q-icon :name="menuItem.icon" />
          </q-item-section>
          <q-item-section>
            <q-item-label>{{ menuItem.label }}</q-item-label>
          </q-item-section>
        </q-item>

        <div class="q-mt-auto">
          <q-item
            v-if="$isAllowed('dealer/account/get')"
            :to="{ name: 'Account' }"
            tag="a"
            clickable
            exact
          >
            <q-item-section avatar>
              <q-icon name="person" />
            </q-item-section>
            <q-item-section>
              <q-item-label>
                {{ accountInfo.user.fullName }}
              </q-item-label>
            </q-item-section>
          </q-item>
          <q-item clickable @click="confirmSignOut">
            <q-item-section avatar>
              <q-icon name="logout" />
            </q-item-section>
            <q-item-section>
              <q-item-label>
                {{ $t('layouts.default.drawer.menu.signOut') }}
              </q-item-label>
            </q-item-section>
          </q-item>
        </div>
      </q-list>
    </q-drawer>

    <q-page-container>
      <q-page class="q-mx-auto q-py-lg q-px-md" style="max-width: 1200px">
        <app-breadcrumbs v-if="$route.name !== 'Dashboard'" />

        <router-view />
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue';

export default {
  components: {
    AppBreadcrumbs,
  },
  data() {
    return {
      leftDrawerOpen: false,
    };
  },
  computed: {
    ...mapGetters({
      accountInfo: 'account/info',
    }),
    menuItems() {
      return [
        {
          path: { name: 'Dashboard' },
          icon: 'dashboard',
          label: this.$t('layouts.default.drawer.menu.dashboard'),
          permissions: 'dealer/dashboard/index',
        },
        {
          path: { name: 'DoctorsIndex' },
          icon: 'group',
          label: this.$t('layouts.default.drawer.menu.doctors'),
          permissions: 'dealer/doctors/list',
        },
      ];
    },
    allowedMenuItems() {
      return this.menuItems.filter((menuItem) =>
        this.$isAllowed(menuItem.permissions)
      );
    },
  },
  created() {
    this.getAccountInfo();
  },
  methods: {
    ...mapActions({
      getAccountInfo: 'account/getAccountInfo',
      signOut: 'account/signOut',
    }),
    confirmSignOut() {
      this.$q
        .dialog({
          title: this.$t('layouts.default.signOutModal.title'),
          message: this.$t('layouts.default.signOutModal.message'),
          ok: this.$t('layouts.default.signOutModal.okButtonTitle'),
          cancel: this.$t('layouts.default.signOutModal.cancelButtonTitle'),
        })
        .onOk(() => this.signOut());
    },
  },
};
</script>
